<template>
  <div
    :class="[
      'mainContainer',
      isShow ? '' : 'hide',
      $store.state.isFooterMenu ? 'menu' : '',
    ]"
  >
    <div class="content">
      <div class="close" @click="actionFGFmodal(false)">
        <img src="@/assets/images/close_gray.svg" alt="" />
      </div>
      <div class="title">
        <div class="icon">
          <img src="@/assets/images/personadd.svg" fill="red" alt="" />
        </div>
        <div class="text">
          {{ lbl.fgf.invitemodal }}
          {{
            ReferralPoints
              ? lbl.fgf.togetmodal + ReferralPoints + lbl.fgf.pointmodal
              : ''
          }}
        </div>
      </div>
      <div class="btnContainer">
        <button
          :style="{ backgroundColor: btnBGColor, color: btnColor }"
          @click="goto('inviter')"
        >
          {{ lbl.fgf.invitebtn }}
        </button>
      </div>
      <div class="seemore" @click="goto('invitedList')">
        {{ lbl.fgf.seeinvitefriends }}
      </div>
    </div>
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import BzbsDashboard from '@/core/Home/BzbsDashboard'

export default {
  name: 'FGFmodal',
  components: {},
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    isShow: Boolean,
  },
  data() {
    return {
      btnColor: '',
      btnBGColor: '',
      StoreType: '',
      ReferralPoints: 0,
      hide: false,
    }
  },
  created() {
    this.getCustomerStore()
    this.getActiveFGF()
  },
  mounted() {},
  methods: {
    actionFGFmodal(state) {
      this.handleshowFGF(state)
      sessionStorage.setItem('handleshowFGF', 'true')
    },
    goto(page) {
      this.$router.push({
        name: page,
      })
    },
    getCustomerStore() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            this.btnBGColor = res.data.StoreDetail.ButtonColor
            this.btnColor = res.data.StoreDetail.ButtonTextColor
            if (res.data.StoreDetail.StoreType !== 'point') {
              this.handleshowFGF(false)
              sessionStorage.setItem('handleshowFGF', 'true')
            }
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            console.log('getCustomerStore error', error)
            resolve(error)
          })
      })
    },
    getActiveFGF() {
      this.handleLoading(true)
      BzbsDashboard.getFGFGenLink()
        .then(res => {
          console.log('getFGFGenLink', res.data.CrmPlusFriendGetFriend)
          if (res.data.CrmPlusFriendGetFriend) {
            this.ReferralPoints = res.data.CrmPlusFriendGetFriend.ReferralPoints
            var toDay = Date.now()
            if (
              res.data.CrmPlusFriendGetFriend.ExpireDate * 1000 >= toDay &&
              res.data.CrmPlusFriendGetFriend.StatusId == 3
            ) {
              this.handleshowFGF(true)
              sessionStorage.setItem('handleshowFGF', 'false')
            } else {
              this.handleshowFGF(false)
              sessionStorage.setItem('handleshowFGF', 'false')
            }
          } else {
            this.handleshowFGF(false)
            sessionStorage.setItem('handleshowFGF', 'false')
          }
        })
        .catch(err => {
          this.handleshowFGF(false)
          sessionStorage.setItem('handleshowFGF', 'false')

          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.mainContainer {
  padding: 18px 12px;
  width: 100%;
  max-width: 390px;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 110px;
  z-index: 2;
  &.hide {
    display: none;
  }
  .content {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    padding: 16px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px #f5f5f5;
    background-color: #fff;
    position: relative;
    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      opacity: 1;
      color: #000;
    }
    .title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 14px;
      .text {
        padding-top: 8px;
        font-size: 16px;
      }
    }
    .btnContainer {
      font-size: 16px;
      font-weight: 500;
      margin-top: 17px;
      button {
        border: none;
        border-radius: 40px;
        width: 100%;
        height: 45px;
      }
    }
    .seemore {
      text-align: center;
      margin-top: 17px;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
@media only screen and (min-width: 600px) {
  .mainContainer {
    bottom: 40px;
    right: 0;
    left: unset;
    transform: unset;
    &.menu {
      bottom: 110px;
    }
  }
}
</style>
